import JsBarcode from 'jsbarcode';
import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { closeAllModals } from '../../../../actions/modalActions';
import { ReactComponent as Close } from '../../../../icons/close-button.svg';
import { A } from '../../../base/typography';
import { P } from '../../../base/typography/typography';
import * as StyledModals from '../myShipmentsModals.styles';

interface Props {}

const Barcode: FC<Props> = () => {
	const dispatch = useDispatch<any>();
	const { t } = useTranslation('registerShipment');

	const closeModal = () => {
		dispatch(closeAllModals());
		document.body.style.overflow = 'unset';
	};
	document.body.style.overflow = 'hidden';

	const { modalHeading, shipmentId, flag } = useSelector(({ modalReducer }) => modalReducer);

	useEffect(() => {
		const generateBarcode = async () => JsBarcode('#barcode', shipmentId);
		generateBarcode();
	});

	return (
		<StyledModals.Wrapper>
			<StyledModals.Heading>
				<div>{modalHeading}</div>
				<A onClick={closeModal}>
					<Close />
				</A>
			</StyledModals.Heading>
			<P>{flag ? t('barcodeInfoPaymentAuthorized') : t('barcodeInfo')}</P>
			<StyledModals.SvgWrapper>
				<svg id="barcode" />
			</StyledModals.SvgWrapper>
		</StyledModals.Wrapper>
	);
};

export default Barcode;
